import { render } from "./talent-page.vue?vue&type=template&id=2e247c78&ts=true"
import script from "./talent-page.vue?vue&type=script&lang=ts"
export * from "./talent-page.vue?vue&type=script&lang=ts"

import "./talent-page.vue?vue&type=style&index=0&id=2e247c78&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__